































































































































































































import { Component } from "vue-property-decorator";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import SceneTypeComponent from "@/app/components/manageSpace/components/sceneType.component.vue";
import ModalSelectSceneComponent from "@/app/components/manageSpace/components/space/customizeSpace/modalSelectScene.component.vue";
import { i18n } from "@/resources/locales";
import { SCENE_FILE } from "@/resources/constants/space";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { Validate } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import ErrorController from "@/resources/mixins/errorController/errorController";
import { MAX_SIZE_FILE } from "@/resources/constants/system";
@Component({
  name: "customize-space-component",
  components: { ModalSelectSceneComponent, SceneTypeComponent },
})
export default class CustomizeSpaceComponent extends mixins(
  NotificationEvent,
  ErrorController
) {
  api = process.env.VUE_APP_API_IMAGE;
  space: SpaceInterface;

  @Validate({ required })
  spaceName = "";
  welcomeText = "";
  changeName = false;
  changeScenario = false;
  openModal = false;
  sceneSelected = null;
  oldScene = null;
  loading = false;
  backgroundImage = null;
  boardImage = null;
  commonImage = null;
  logoImage = null;
  logoImageUrl = "";
  backgroundImageUrl = "";
  boardImageUrl = "";
  commonImageUrl = "";
  constructor() {
    super();
    this.sceneSelected = null;
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    this.spaceName = space.name;
    this.welcomeText = space.welcomeText;
    this.space = space;
  }
  selectScene(event: any): void {
    this.oldScene = this.space.scenario.scenarioType;
    this.sceneSelected = event;
    this.space.scenario.scenarioType = event;
  }
  mounted(): void {
    this.$store.dispatch("SpaceStore/getSceneTypesAction", {
      spaceType: this.space.type,
      superSpaceId: this.space.superSpace.id,
      callback: () => {
        // do nothing.
      },
    });
    this.$store.dispatch("SpaceStore/getSpaceAction", {
      spaceId: this.space.id,
      callback: async () => {
        // do nothing
      },
      callbackError: (error) => {
        if (error.response && error.response.status == 403) {
          this.checkError(error);
        }
      },
    });
  }
  selectFile(ref): void {
    if (this.$refs[ref]["files"][0].size >= MAX_SIZE_FILE) {
      this.onError(
        this.$i18n.t("notifications.titles.error"),
        this.$i18n.t("notifications.errorMessages.maxFileSize")
      );
      return;
    }
    const allImages = ["image/png", "image/jpg", "image/jpeg"];
    if (allImages.indexOf(this.$refs[ref]["files"][0].type) < 0) {
      this.onError(
        this.$i18n.t("notifications.titles.error"),
        this.$i18n.t("notifications.errorMessages.fileType")
      );
      return;
    }
    if (this.$refs[ref]["files"].length > 0) {
      this[ref] = this.$refs[ref]["files"];
      const fr = new FileReader();
      setTimeout(() => {
        const img = document.getElementById(ref);
        fr.onload = (event) => {
          if (event) {
            if (img instanceof HTMLImageElement) {
              img.src = event ? event?.target.result.toString() : "";
              this[ref + "Url"] = event ? event?.target.result.toString() : "";
            }
          }
        };
        fr.readAsDataURL(this[ref][0]);
      }, 200);
    }
  }
  beforeDestroy(): void {
    if (this.sceneSelected) {
      this.space.scenario.scenarioType = this.oldScene;
      this.sceneSelected = null;
    }
    this.changeName = false;
  }
  async onSave(): Promise<void> {
    if (
      this.changeName ||
      this.sceneSelected ||
      this.boardImage ||
      this.commonImage ||
      this.logoImage
    )
      this.loading = true;
    if (this.changeName) {
      await this.$store.dispatch("SpaceStore/updateSpaceAction", {
        spaceId: this.space.id,
        payload: {
          name: this.spaceName,
          welcomeText: this.welcomeText,
        },
        callback: () => {
          if (!this.sceneSelected) this.onSaveEnd();
        },
        callbackError: (error) => {
          if (error.data.detail.includes("name:")) {
            this.onError(
              i18n.t("notifications.titles.error"),
              i18n.t("notifications.apiMessage.SUPER_SPACE_NAME_EXISTS")
            );
          }
          this.loading = false;
        },
      });
    }
    if (this.sceneSelected) {
      await this.$store.dispatch("SpaceStore/updateSceneAction", {
        spaceId: this.space.id,
        data: { scenarioType: { id: this.sceneSelected.id } },
        callback: () => {
          this.sceneSelected = null;
          if (!this.backgroundImage) this.onSaveEnd();
        },
      });
    }
    if (this.backgroundImage) {
      const formData = new FormData();
      formData.append("file", this.backgroundImage[0] || "");
      formData.append("space", `${this.space.id}`);
      formData.append("type", SCENE_FILE.BACKGROUND_IMAGE);
      await this.$store.dispatch("SpaceStore/uploadSpaceFileAction", {
        data: formData,
        callback: (data) => {
          const img = document.getElementById("backgroundImage");
          if (img instanceof HTMLImageElement) {
            img.src = data.url;
            this.backgroundImageUrl = data.url;
          }
          this.onSaveEnd();
        },
        callbackError: () => {
          this.loading = false;
          this.onError("", i18n.t("notifications.genericError.updateImage"));
        },
      });
    }
    if (this.boardImage) {
      const formData = new FormData();
      formData.append("file", this.boardImage[0] || "");
      formData.append("space", `${this.space.id}`);
      formData.append("type", SCENE_FILE.BOARD_IMAGE);
      await this.$store.dispatch("SpaceStore/uploadSpaceFileAction", {
        data: formData,
        callback: (data) => {
          const img = document.getElementById("boardImage");
          if (img instanceof HTMLImageElement) {
            img.src = data.url;
            this.boardImageUrl = data.url;
            this.space.boardImage = data;
          }
          this.onSaveEnd();
        },
        callbackError: () => {
          this.loading = false;
          this.onError("", i18n.t("notifications.genericError.updateImage"));
        },
      });
    }
    if (this.commonImage) {
      const formData = new FormData();
      formData.append("file", this.commonImage[0] || "");
      formData.append("space", `${this.space.id}`);
      formData.append("type", SCENE_FILE.COMMON_IMAGE);
      await this.$store.dispatch("SpaceStore/uploadSpaceFileAction", {
        data: formData,
        callback: (data) => {
          const img = document.getElementById("commonImage");
          if (img instanceof HTMLImageElement) {
            img.src = data.url;
            this.commonImageUrl = data.url;
            this.space.commonImage = data;
          }
          this.onSaveEnd();
        },
        callbackError: () => {
          this.loading = false;
          this.onError("", i18n.t("notifications.genericError.updateImage"));
        },
      });
    }
    if (this.logoImage) {
      const formData = new FormData();
      formData.append("file", this.logoImage[0] || "");
      formData.append("space", `${this.space.id}`);
      formData.append("type", SCENE_FILE.LOGO_IMAGE_TYPE);
      await this.$store.dispatch("SpaceStore/uploadSpaceFileAction", {
        data: formData,
        callback: (data) => {
          const img = document.getElementById("logoImage");
          if (img instanceof HTMLImageElement) {
            img.src = data.url;
            this.logoImageUrl = data.url;
            this.space.logoImage = data;
          }
          this.onSaveEnd();
        },
        callbackError: (error) => {
          this.loading = false;
          this.onError("", i18n.t("notifications.genericError.updateImage"));
        },
      });
    }
  }
  onSaveEnd(): void {
    this.loading = false;
    this.backgroundImage = null;
    this.boardImage = null;
    this.commonImage = null;
    this.logoImage = null;
    this.onSuccess(
      i18n.t("notifications.titles.success"),
      i18n.t("notifications.descriptions.spaceUpdate")
    );
  }
  async removeImage(): Promise<void> {
    if (!this.space.logoImage.id) return;
    await this.$store.dispatch("SpaceStore/removeImageSpaceAction", {
      imageId: this.space.logoImage.id,
      callback: (response) => {
        this.logoImageUrl = "";
        this.space.logoImage = null;
      },
      callbackError: (error) => {
        this.onError("", i18n.t("notifications.genericError.updateImage"));
      },
    });
  }
  async removeImagePoster(): Promise<void> {
    if (!this.space.boardImage.id) return;
    await this.$store.dispatch("SpaceStore/removeImageSpaceAction", {
      imageId: this.space.boardImage.id,
      callback: (response) => {
        this.boardImage = "";
        this.space.boardImage = null;
      },
      callbackError: (error) => {
        this.onError("", i18n.t("notifications.genericError.updateImage"));
      },
    });
  }
  async removeImageCommon(): Promise<void> {
    if (!this.space.commonImage.id) return;
    await this.$store.dispatch("SpaceStore/removeImageSpaceAction", {
      imageId: this.space.commonImage.id,
      callback: (response) => {
        this.commonImage = "";
        this.space.commonImage = null;
      },
      callbackError: (error) => {
        this.onError("", i18n.t("notifications.genericError.updateImage"));
      },
    });
  }
  async convertRelativeUriToFile(filePath, fileName, mimeType, cb) {
    mimeType =
      mimeType ||
      `image/${filePath.split(".")[filePath.split(".").length - 1]}`;
    const imageUrl = await fetch(filePath);
    const buffer = await imageUrl.arrayBuffer();
    cb(new File([buffer], fileName, { type: mimeType }));
  }
}
